import { MODAL_OPEN_REQUEST, MODAL_CLOSE_REQUEST } from './constants';

export const registerModalOpen = () => ({
  type: MODAL_OPEN_REQUEST
});

export const registerModalClose = () => ({
  type: MODAL_CLOSE_REQUEST
});
